import { colors, fontWeights } from '../../../constants/salesStyles'
import { carFields } from '../../../types/car/carTypes'
import { fieldTypes, valueTypes } from '../../../types/common/commonTypes'
import {
    Marketplaces,
    MarketplacesKeys,
    partFields,
    partState,
    customBrandTypes,
    coversTypes,
    audioTypes,
    wheelTypes,
    oilTypes,
    radioTypes,
    amplifierTypes,
} from '../../../types/part/partTypes'

export const initialPartState: partState = {
    fields: [
        {
            field: partFields.useExistingCar,
            fieldType: fieldTypes.void,
            value: 0,
            valueType: valueTypes.number,
            title: 'Автомобиль',
            specialProps: {
                switchRenderOptions: ['НЕТ', 'Выбрать', 'Изменить'],
                column: 1,
            },
        },
        {
            field: partFields.carId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Автомобиль',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 1 }],
                renderValue: '',
                column: 1,
            },
        },
        {
            field: carFields.markId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            title: 'Марка',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 2 }],
                column: 1,
                renderValue: '',
            },
        },
        {
            field: carFields.modelId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            title: 'Модель',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 2 }],
                fieldParent: carFields.markId,
                column: 1,
            },
        },
        {
            field: carFields.modificationId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            title: 'Модификация',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 2 }],
                fieldParent: carFields.modelId,
                column: 1,
            },
        },
        {
            field: carFields.year,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            title: 'Год',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 2 }],
                fieldParent: carFields.modificationId,
                column: 1,
            },
        },
        {
            field: partFields.bodycars,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Модель кузова',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 2 }],
                column: 1,
            },
        },
        {
            field: partFields.engine,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Модель двигателя',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.useExistingCar, value: 2 }],
                column: 1,
            },
        },
        {
            field: partFields.groupId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            title: 'Категория',
            specialProps: {
                placeholder: 'определяется автоматически',
                column: 1,
            },
        },
        {
            field: partFields.typeId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            /*
                13000 - колёса в сборе
                13003 - запасное колесо

                13001 - шины
                13004 - шина

                13002 - диски
                13005 - диск

                9072 - аккумулятор

                13013 - Колпаки колесные

                255 - Антифриз - охлаждающие жидкости
                256 - Тормозная жидкость - тормозные жидкости
                257 - Жидкость ГУР - гидравлические жидкости
                258 - Масло двухтактное - моторные масла
                260 - Моторное масло - моторные масла

                10045 - Магнитола

                10072 - Динамики передние
                10073 - Динамики задние
                10074 - Динамики высоких частот
                10075 - Сабвуфер

                10076 - Усилитель звуковой
            */
            // value: 0,
            title: 'Название',
            specialProps: {
                column: 1,
            },
        },
        {
            field: partFields.RadioBrand,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Производитель',
            specialProps: {
                isVisibleAny: [...radioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'radio',
            },
        },
        {
            field: partFields.RadioSize,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Размер',
            specialProps: {
                isVisibleAny: [...radioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                column: 1,
                extraHandle: 'radio',
                options: ['1 DIN', '2 DIN', 'Штатное место'],
            },
        },
        {
            field: partFields.AndroidOS,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            value: 0,
            title: 'Андройд ОС',
            specialProps: {
                isVisibleAny: [...radioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                column: 1,
                extraHandle: 'AndroidOS',
                switchRenderOptions: ['Нет', 'Да'],
            },
        },
        {
            field: partFields.RAM,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Оперативная память (Гб)',
            specialProps: {
                isVisibleEvery: [
                    [...radioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                    [{ field: partFields.AndroidOS, value: 1 }],
                ],
                column: 1,
                extraHandle: 'radio',
            },
        },
        {
            field: partFields.ROM,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Встроена память (Гб)',
            specialProps: {
                isVisibleEvery: [
                    [...radioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                    [{ field: partFields.AndroidOS, value: 1 }],
                ],
                column: 1,
                extraHandle: 'radio',
            },
        },
        {
            field: partFields.CPU,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Ядра процессора',
            specialProps: {
                isVisibleEvery: [
                    [...radioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                    [{ field: partFields.AndroidOS, value: 1 }],
                ],
                column: 1,
                extraHandle: 'radio',
            },
        },
        {
            field: partFields.AmplifierBrand,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Производитель',
            specialProps: {
                isVisibleAny: [...amplifierTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'amplifier',
            },
        },
        {
            field: partFields.AmplifierType,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            value: 0,
            title: 'Тип усилителя',
            specialProps: {
                isVisibleAny: [...amplifierTypes.map(i => ({ field: partFields.typeId, value: i }))],
                column: 1,
                extraHandle: 'amplifierType',
                switchRenderOptions: ['Штатный', 'Универсальный'],
                customWidth: 176,
            },
        },
        {
            field: partFields.ChannelsNumber,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Количество каналов',
            specialProps: {
                isVisibleEvery: [
                    [...amplifierTypes.map(i => ({ field: partFields.typeId, value: i }))],
                    [{ field: partFields.AmplifierType, value: 1 }],
                ],
                column: 1,
                extraHandle: 'amplifier',
            },
        },
        {
            field: partFields.RMSfour,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Ном.мощность на канал (4 Ом), Вт',
            specialProps: {
                isVisibleEvery: [
                    [...amplifierTypes.map(i => ({ field: partFields.typeId, value: i }))],
                    [{ field: partFields.AmplifierType, value: 1 }],
                ],
                column: 1,
                extraHandle: 'amplifier',
            },
        },
        {
            field: partFields.RMStwo,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Ном.мощность на канал (2 Ом), Вт',
            specialProps: {
                isVisibleEvery: [
                    [...amplifierTypes.map(i => ({ field: partFields.typeId, value: i }))],
                    [{ field: partFields.AmplifierType, value: 1 }],
                ],
                column: 1,
                extraHandle: 'amplifier',
            },
        },
        {
            field: partFields.AudioBrand,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Производитель',
            specialProps: {
                isVisibleAny: [...audioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'audio',
            },
        },
        {
            field: partFields.AudioType,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Тип автоакустики',
            specialProps: {
                isVisibleAny: [...audioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'audio',
                options: [
                    'Эстрадная',
                    'Компонентная',
                    'Коаксиальная',
                    'Среднечастотная',
                    'Широкополосная',
                    'Корпусная',
                    'Сабвуфер',
                    'Твитер',
                ],
            },
        },
        {
            field: partFields.VoiceCoil,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Количество полос',
            specialProps: {
                isVisibleAny: [...audioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'audio',
                options: ['1', '2', '3', '4', '5'],
            },
        },
        {
            field: partFields.AudioSize,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Типоразмер',
            specialProps: {
                isVisibleAny: [...audioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'audio',
            },
        },
        {
            field: partFields.RMS,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.number,
            title: 'Номинальная мощность, Вт',
            specialProps: {
                isVisibleAny: [...audioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                column: 1,
                extraHandle: 'audio',
            },
        },
        {
            field: partFields.Impedance,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Импеданс, Ом',
            specialProps: {
                isVisibleAny: [...audioTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'audio',
                options: ['1×1', '2', '2×2', '3', '3.4', '3.6', '3.7', '4', '4×4', '5', '6', '7', '8'],
            },
        },
        {
            field: partFields.Quantity,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Количество',
            specialProps: {
                isVisibleAny: [...wheelTypes.map(i => ({ field: partFields.typeId, value: i }))],
                hoverText: 'Количество шт. в комплекте. От 1 до 8',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.TireType,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Сезонность',
            specialProps: {
                isVisibleAny: [...wheelTypes.map(i => ({ field: partFields.typeId, value: i }))],
                hoverText: 'Сезонность: Всесезонные, Летние, Зимние нешипованные, Зимние шипованные',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.TireYear,
            fieldType: fieldTypes.input,
            valueType: valueTypes.number,
            title: 'Год выпуска',
            value: '',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13001 },
                    { field: partFields.typeId, value: 13004 },
                ],
                isRequired: true,
                column: 1,
                extraHandle: 'wheels',
                maxLength: 4,
            },
        },
        {
            field: partFields.RimType,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Тип диска',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13000 },
                    { field: partFields.typeId, value: 13003 },
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                ],
                hoverText: 'Тип диска: Кованые, Литые, Штампованные, Спицованные, Сборные',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.TireBrand,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Бренд',
            specialProps: {
                isVisibleAny: [...wheelTypes.map(i => ({ field: partFields.typeId, value: i }))],
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.TireModel,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Модель',
            specialProps: {
                isVisibleAny: [...wheelTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.TireBrand,
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.RimDiameter,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Диаметр',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                    { field: partFields.typeId, value: 13013 },
                    ...wheelTypes.map(i => ({ field: partFields.typeId, value: i })),
                ],
                hoverText: 'Диаметр, дюймы',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.TireSectionWidth,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Ширина профиля',
            specialProps: {
                isVisibleAny: [...wheelTypes.map(i => ({ field: partFields.typeId, value: i }))],
                hoverText: 'Ширина профиля шины',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.TireAspectRatio,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Высота профиля',
            specialProps: {
                isVisibleAny: [...wheelTypes.map(i => ({ field: partFields.typeId, value: i }))],
                hoverText: 'Высота профиля шины',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.ResidualTreadWheels,
            fieldType: fieldTypes.input,
            valueType: valueTypes.number,
            title: 'Остаток протектора',
            value: '',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13001 },
                    { field: partFields.typeId, value: 13004 },
                ],
                column: 1,
                extraHandle: 'wheels',
                maxLength: 2,
            },
        },
        {
            field: partFields.TireRuptureQuantity,
            fieldType: fieldTypes.select,
            valueType: valueTypes.string,
            title: 'Шины с грыжами',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13001 },
                    { field: partFields.typeId, value: 13004 },
                ],
                column: 1,
                extraHandle: 'wheels',
                maxLength: 2,
                options: ['Грыж нет', '1', '2', 'Более 2'],
            },
        },
        {
            field: partFields.TireSideRepairQuantity,
            fieldType: fieldTypes.select,
            valueType: valueTypes.string,
            title: 'Шины с ремонтом',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13001 },
                    { field: partFields.typeId, value: 13004 },
                ],
                column: 1,
                extraHandle: 'wheels',
                maxLength: 2,
                options: ['Ремонтов нет', '1', '2', 'Более 2'],
            },
        },
        {
            field: partFields.OtherDefects,
            fieldType: fieldTypes.select,
            valueType: valueTypes.string,
            title: 'Другие дефекты',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13001 },
                    { field: partFields.typeId, value: 13004 },
                ],
                column: 1,
                extraHandle: 'wheels',
                maxLength: 2,
                options: [
                    'Без дефектов',
                    'Неравномерный износ',
                    'Выпало больше 50% шипов',
                    'Отслоение протектора',
                    'Трещины на шинах',
                    'Проехали на спущенных',
                ],
            },
        },
        {
            field: partFields.RimWidth,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Ширина обода',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13000 },
                    { field: partFields.typeId, value: 13003 },
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                ],
                hoverText: 'Ширина обода, дюймы',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.RimOffset,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Вылет (ET)',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13000 },
                    { field: partFields.typeId, value: 13003 },
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                ],
                hoverText: 'Вылет (ET)',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.RimBolts,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Болты',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13000 },
                    { field: partFields.typeId, value: 13003 },
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                ],
                hoverText: 'Количество отверстий под болты',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.RimBoltsDiameter,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Диаметр под болты',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13000 },
                    { field: partFields.typeId, value: 13003 },
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                ],
                hoverText: 'Диаметр расположения отверстий под болты',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.RimDIA,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Диаметр ЦО',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 13000 },
                    { field: partFields.typeId, value: 13003 },
                    { field: partFields.typeId, value: 13002 },
                    { field: partFields.typeId, value: 13005 },
                ],
                hoverText: 'Диаметр центрального отверстия',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.OilBrand,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Производитель',
            specialProps: {
                isVisibleAny: [...oilTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.SAE,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Класс вязкости',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 258 },
                    { field: partFields.typeId, value: 260 },
                ],
                fieldParent: partFields.typeId,
                hoverText: 'Класс вязкости SAE',
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.Volume,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Объём',
            specialProps: {
                isVisibleAny: [...oilTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.ACEA,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Стандарт ACEA',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 258 },
                    { field: partFields.typeId, value: 260 },
                ],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.API,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Стандарт API',
            specialProps: {
                isVisibleAny: [
                    { field: partFields.typeId, value: 258 },
                    { field: partFields.typeId, value: 260 },
                ],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.OEMOil,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Допуски OEM',
            specialProps: {
                isVisibleAny: [...oilTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.Color,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Цвет',
            specialProps: {
                isVisibleAny: [{ field: partFields.typeId, value: 255 }],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.ASTM,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Стандарт ASTM',
            specialProps: {
                isVisibleAny: [{ field: partFields.typeId, value: 255 }],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.DOT,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Стандарт DOT',
            specialProps: {
                isVisibleAny: [{ field: partFields.typeId, value: 256 }],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'oils',
            },
        },
        {
            field: partFields.CoverType,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Тип коврика',
            specialProps: {
                isVisibleAny: [...coversTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'covers',
            },
        },
        {
            field: partFields.Material,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Материал',
            specialProps: {
                isVisibleAny: [...coversTypes.map(i => ({ field: partFields.typeId, value: i }))],
                fieldParent: partFields.typeId,
                column: 1,
                extraHandle: 'covers',
            },
        },
        {
            field: partFields.customTitle,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Название публикации',
            specialProps: {
                column: 1,
            },
        },
        {
            field: partFields.conditionId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.number,
            title: 'Состояние',
            specialProps: {
                fieldParent: partFields.typeId,
                column: 1,
            },
        },
        {
            field: partFields.PartBrand,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Бренд запчасти',
            specialProps: {
                isVisibleAny: [
                    ...[{ field: partFields.conditionId, value: 1 }],
                    ...customBrandTypes.map(i => ({ field: partFields.typeId, value: i })),
                ],
                isRequired: true,
                column: 1,
                extraHandle: 'new',
            },
        },
        {
            field: partFields.ResidualTread,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Глубина протектора',
            specialProps: {
                isVisibleEvery: [
                    [
                        { field: partFields.conditionId, value: 2 },
                        { field: partFields.conditionId, value: 3 },
                        { field: partFields.conditionId, value: 4 },
                    ],
                    [
                        { field: partFields.typeId, value: 13000 },
                        { field: partFields.typeId, value: 13003 },
                        // { field: partFields.typeId, value: 13001 },
                        // { field: partFields.typeId, value: 13004 },
                    ],
                ],
                hoverText:
                    'Остаточная глубина протектора шины. Может принимать значения от 1 до 50 включительно, измеряется в миллиметрах (мм) В диапазоне 1-10 мм включительно можно использовать дробные значения.',
                column: 1,
                extraHandle: 'wheels',
            },
        },
        {
            field: partFields.position,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Расположение',
            specialProps: {
                placeholder: 'определяется автоматически',
                column: 1,
            },
        },
        {
            field: partFields.partNumber,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Основной OEM номер',
            specialProps: {
                column: 1,
                maxAddedFields: 14,
                alignItemsStretch: true,
            },
        },
        {
            field: partFields.partId,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Avito ID',
            specialProps: {
                placeholder: 'определяется автоматически',
                column: 1,
                copyButton: true,
                readOnlyTextOverlowEllipsis: true,
            },
        },
        {
            field: partFields.noValue,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Описание',
            specialProps: {
                placeholder: '',
                column: 1,
            },
        },
        {
            field: partFields.description,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: '',
            specialProps: {
                textareaMinHeight: 400,
                textareaMaxLength: 7500,
                column: 1,
                isFullWidth: true,
            },
        },
        {
            field: partFields.partPricePurchase,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.price,
            title: 'Цена закупки',
            specialProps: {
                isRequired: false,
                column: 2,
            },
        },
        {
            field: partFields.partPrice,
            fieldType: fieldTypes.readOnly,
            value: 0,
            valueType: valueTypes.price,
            title: 'Цена продажи',
            specialProps: {
                isRequired: false,
                column: 2,
                alignItemsStretch: true,
            },
        },
        {
            field: partFields.partImages,
            fieldType: fieldTypes.void,
            valueType: valueTypes.string,
            title: '',
            specialProps: {
                column: 2,
                extraHandle: 'partImages',
            },
        },
        {
            field: partFields.warehouseTitle,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Склад',
            specialProps: {
                column: 2,
            },
        },
        {
            field: partFields.warehouseRow,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Номер ряда',
            specialProps: {
                column: 2,
            },
        },
        {
            field: partFields.warehouseShelf,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Номер полки',
            specialProps: {
                column: 2,
            },
        },
        {
            field: partFields.warehousePlace,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Номер места',
            specialProps: {
                column: 2,
            },
        },
        {
            field: partFields.warehouseSection,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Секция',
            specialProps: {
                column: 2,
            },
        },
        {
            field: partFields.vendorCode,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Артикул',
            specialProps: {
                column: 2,
                maxLength: 20,
                copyButton: true,
                printerButton: true,
            },
        },
        {
            field: partFields.VideoUrl,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Ссылка на видео',
            specialProps: {
                column: 2,
            },
        },
        {
            field: partFields.IncomingInvoice,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            value: '',
            title: 'Приходная накладная',
            specialProps: {
                placeholder: 'не выбрано',
                column: 2,
            },
        },
        {
            field: partFields.marketplacesDest,
            fieldType: fieldTypes.checkboxGroup,
            valueType: valueTypes.array,
            value: Object.keys(Marketplaces).map(key => ({
                field: key as MarketplacesKeys,
                value: false,
            })),
            title: 'Разместить на маркетплейсах',
            specialProps: {
                column: 2,
                extraHandle: 'marketplacesDest',
                checkboxItems: Object.entries(Marketplaces).map(([key, title]) => ({
                    field: key as MarketplacesKeys,
                    fieldType: fieldTypes.checkbox,
                    valueType: valueTypes.boolean,
                    value: false,
                    title,
                    specialProps: {
                        column: 2,
                        extraHandle: 'marketplacesDest',
                    },
                })),
            },
        },
        {
            field: partFields.applicability,
            fieldType: fieldTypes.applicability,
            valueType: valueTypes.boolean,
            value: false,
            title: 'Применимость',
            specialProps: {
                column: 2,
                isTitleFullWidth: true,
                isShowAccordionButton: true,
            },
        },
        {
            field: partFields.noValue,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.string,
            title: 'Добавленные',
            specialProps: {
                isVisibleEvery: [
                    [{ field: partFields.applicabilitySelected, value: true }],
                    [{ field: partFields.applicability, value: true }],
                ],
                column: 2,
                isTitleFullWidth: true,
                rowHeight: 40,
                borderColor: colors.grayLighter,
                fontWeight: fontWeights.normal,
            },
        },
        {
            field: partFields.applicabilitySelected,
            fieldType: fieldTypes.applicabilitySelected,
            valueType: valueTypes.boolean,
            value: false,
            title: '',
            specialProps: {
                isVisibleEvery: [
                    [{ field: partFields.applicabilitySelected, value: true }],
                    [{ field: partFields.applicability, value: true }],
                ],
                borderTop: false,
                column: 2,
                isFullWidth: true,
                applicabilityItems: [],
                rowHeight: 50,
                readOnly: true,
            },
        },
        {
            field: partFields.dimensionsAndWeight,
            fieldType: fieldTypes.readOnly,
            valueType: valueTypes.boolean,
            title: 'Габариты и вес с упаковкой',
            value: false,
            specialProps: {
                column: 2,
                isTitleFullWidth: true,
                isShowAccordionButton: true,
            },
        },
        {
            field: partFields.height,
            fieldType: fieldTypes.readOnly,
            value: '',
            valueType: valueTypes.string,
            title: 'Высота, см',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.dimensionsAndWeight, value: true }],
                column: 2,
                borderTop: false,
            },
        },
        {
            field: partFields.width,
            fieldType: fieldTypes.readOnly,
            value: '',
            valueType: valueTypes.string,
            title: 'Ширина, см',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.dimensionsAndWeight, value: true }],
                column: 2,
                borderTop: false,
            },
        },
        {
            field: partFields.length,
            fieldType: fieldTypes.readOnly,
            value: '',
            valueType: valueTypes.string,
            title: 'Длина, см',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.dimensionsAndWeight, value: true }],
                column: 2,
                borderTop: false,
            },
        },
        {
            field: partFields.weight,
            fieldType: fieldTypes.readOnly,
            value: '',
            valueType: valueTypes.string,
            title: 'Вес, кг',
            specialProps: {
                isVisibleSwitch: [{ field: partFields.dimensionsAndWeight, value: true }],
                column: 2,
                borderTop: false,
            },
        },
    ],
}
